import React from 'react'
import {CarouselProvider} from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import Carousel from '../components/carousel'
import bem from '../helpers/bem'

const block = 'board';

const useCarousel = (props) => {
  const {
    players,
    visibleSlides,
    isPOC,
    isSlidesOverflow,
  } = props;

  return (
    <CarouselProvider
      naturalSlideWidth={1}
      naturalSlideHeight={1}
      totalSlides={players.length}
      visibleSlides={visibleSlides}
      className={bem({
        block,
        elem: 'slider-players',
        mods: {'is-poc': isPOC, 'less-height': !isSlidesOverflow}
      })}
    >
      <Carousel
        {...props}
      />
    </CarouselProvider>
  )
};

export default useCarousel;